<template>
  <FullPopup
    :title="popupTitle"
    :is-close-button="false"
    @on-click-back="onClickBack"
  >
    <template #contents>
      <section class="popup-notice">
        <h1 class="title" v-html="title"></h1>
        <p class="description" v-html="description"></p>
        <div class="button-area">
          <button
            type="button"
            class="button-confirm"
            @click="onConfirm"
            v-html="confirmText"
          ></button>
          <button type="button" class="button-cancel" @click="onClickBack">
            취소
          </button>
        </div>
      </section>
    </template>
  </FullPopup>
</template>
<script setup>
  import { defineProps, defineEmits, computed } from 'vue'
  import { getTextBreaks } from '@/common/util/string-manipulation/get-text-breaks'
  import { EventBus } from '@/components/eventbus/EventBus'
  import { MODAL_NOTICE_CONFIRM } from '@/common/resources/const'
  import FullPopup from '@/components/ui/FullPopup.vue'

  const props = defineProps({
    payloads: {
      type: Object,
      default: () => ({}),
    },
  })
  const emit = defineEmits(['on-confirm', 'on-cancel'])

  const popupTitle = computed(
    () => getTextBreaks(props.payloads?.popupTitle) ?? '',
  )
  const title = computed(() => getTextBreaks(props.payloads?.title) ?? '')
  const description = computed(
    () => getTextBreaks(props.payloads?.description) ?? '',
  )
  const confirmText = computed(
    () => getTextBreaks(props.payloads?.confirmText) ?? '',
  )
  const onConfirm = () => {
    EventBus.$emit(MODAL_NOTICE_CONFIRM, {
      isSuccess: true,
      payloads: props.payloads,
    })
  }

  const onClickBack = () => {
    EventBus.$emit(MODAL_NOTICE_CONFIRM, { isSuccess: false, payloads: {} })
  }
</script>
<style scoped lang="scss">
  .popup-notice {
    margin-top: 154px;
    .title {
      font-size: 20px;
      font-weight: normal;
      line-height: 1.4em;
      text-align: center;
      color: #fff;
    }
    .description {
      margin-top: 20px;
      font-size: 14px;
      line-height: 1.42em;
      text-align: center;
      color: #a5a5a5;
    }
    .button-area {
      position: absolute;
      bottom: 28px;
      left: 50%;
      width: 100%;
      min-width: 375px;
      transform: translate(-50%, 0);
      padding: 0 12px;
      background-color: #1b1b1b;
      > button {
        display: block;
        width: 100%;
        padding: 12px 0;
        border-radius: 30px;
        color: #fff;
        background-color: #0050ff;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.44;
        & + button {
          margin-top: 8px;
        }
        &.button-confirm {
          background: #1351f9;
        }
        &.button-cancel {
          background: #5e5e5e;
        }
      }
    }
  }
</style>
<style lang="scss">
  .popup-notice {
    .description {
      > .noti-more {
        color: #fff;
        text-decoration: underline;
      }
    }
  }
</style>
